import React from 'react';
import { Button } from '@/components/ui/button';
import { useGameStore } from '@/store/gameStore';
import { 
  RotateCcw, 
  Flag,
  Save,
  FolderOpen,
  FlipVertical,
  Settings
} from 'lucide-react';

const ControlBar = ({ onSave, onLoad, onSettings }) => {
  const { 
    history, 
    undo, 
    resign, 
    gameStatus,
    boardTheme,
    playerColor
  } = useGameStore();
  
  const canUndo = history.length >= 2 && gameStatus === 'playing';
  const canResign = gameStatus === 'playing';
  
  return (
    <div 
      className={`
        flex flex-wrap gap-2 justify-center p-4 rounded-xl
        ${boardTheme === 'cosmic' 
          ? 'bg-slate-900/80 border border-purple-500/30' 
          : 'bg-amber-50 border border-amber-200'
        }
      `}
      data-testid="control-bar"
    >
      <Button
        data-testid="undo-btn"
        variant="outline"
        size="sm"
        onClick={undo}
        disabled={!canUndo}
        className={`
          ${boardTheme === 'cosmic'
            ? 'bg-slate-800 border-purple-500/30 text-purple-300 hover:bg-purple-900/30 disabled:opacity-30'
            : 'bg-white border-amber-300 text-amber-800 hover:bg-amber-100 disabled:opacity-30'
          }
        `}
      >
        <RotateCcw className="w-4 h-4 mr-1" />
        Undo
      </Button>
      
      <Button
        data-testid="save-btn"
        variant="outline"
        size="sm"
        onClick={onSave}
        className={`
          ${boardTheme === 'cosmic'
            ? 'bg-cyan-900/30 border-cyan-500/30 text-cyan-400 hover:bg-cyan-900/50'
            : 'bg-green-100 border-green-300 text-green-800 hover:bg-green-200'
          }
        `}
      >
        <Save className="w-4 h-4 mr-1" />
        Save
      </Button>
      
      <Button
        data-testid="load-btn"
        variant="outline"
        size="sm"
        onClick={onLoad}
        className={`
          ${boardTheme === 'cosmic'
            ? 'bg-purple-900/30 border-purple-500/30 text-purple-400 hover:bg-purple-900/50'
            : 'bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200'
          }
        `}
      >
        <FolderOpen className="w-4 h-4 mr-1" />
        Load
      </Button>
      
      <Button
        data-testid="resign-btn"
        variant="outline"
        size="sm"
        onClick={resign}
        disabled={!canResign}
        className={`
          ${boardTheme === 'cosmic'
            ? 'bg-red-900/30 border-red-500/30 text-red-400 hover:bg-red-900/50 disabled:opacity-30'
            : 'bg-red-100 border-red-300 text-red-800 hover:bg-red-200 disabled:opacity-30'
          }
        `}
      >
        <Flag className="w-4 h-4 mr-1" />
        Resign
      </Button>
      
      <Button
        data-testid="settings-btn"
        variant="outline"
        size="sm"
        onClick={onSettings}
        className={`
          ${boardTheme === 'cosmic'
            ? 'bg-slate-800 border-slate-600 text-gray-400 hover:bg-slate-700'
            : 'bg-gray-100 border-gray-300 text-gray-600 hover:bg-gray-200'
          }
        `}
      >
        <Settings className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default ControlBar;
